import { getColumnsCount } from './getColumnsCount';
import { getIsHeaderNamed } from './getIsHeaderNamed';
var getHeaderOddNamesCount = function (optionName) {
    if (!getIsHeaderNamed(optionName)) {
        return 0;
    }
    return getColumnsCount(optionName);
};
export { getHeaderOddNamesCount };
